import styled from "styled-components";
export const MenuItem = styled.ul`
  position: absolute;
  box-shadow: 0 2px 10px 0 ${({ theme }) => theme.colors.Gray};
  z-index: 3;
`;

export const MenuItemOption = styled.li<{ highlight: boolean }>`
  :hover {
    background-color: ${({theme}) => theme.colors.GrayLightTwo};
  }

  background-color: ${(props) => (props.highlight ? "#f6f6f6" : "")};
`;
